<template>
  <div class="drug-container container">
    <span class="basic-title">院内准备：</span>
    <drug-edit
      v-if="!isShowPatient"
      ref="editRef"
      class="drug-info substance"
    />
    <drug-look
      v-else
      class="drug-info substance"
    />
  </div>
</template>
<script>
import DrugEdit from "@/components/patientsSmart/drugs/DrugEdit";
import DrugLook from "@/components/patientsSmart/drugs/DrugLook";
import { mapState } from "vuex";

export default {
  name: "Drug",
  components: {
    DrugLook,
    DrugEdit
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),
    isShowPatient() {
      return this.patient?.pageInfo?.isShowPatient;
    },
  },
};
</script>

<style lang="scss" scoped>
.drug-info {
  padding-top: 12px; // 分区信息标题(已经缩了12px了)

}
</style>
